import React from 'react';
import SmetaForm from './SmetaForm';

class SmetaPage extends React.Component {
  render() {
    return (
      <div>
        <SmetaForm />
      </div>
    );
  }
}

export default SmetaPage;



// WEBPACK FOOTER //
// ./src/components/smeta/SmetaPage.js